import { signalStoreFeature, withMethods } from '@ngrx/signals';
import { IChannelProviderStore } from './channel-provider.public';

export function witChannelProviders(
    channelProviderStore: IChannelProviderStore,
) {
    return signalStoreFeature(
        withMethods(() => ({
            getChannelProvidersByWorkflowId: (workflowId: string) =>
                channelProviderStore.getChannelProvidersByWorkflowId(
                    workflowId,
                ),
        })),
    );
}
